import { render } from "./graficheCategoriesTab.vue?vue&type=template&id=0b683897&scoped=true"
import script from "./graficheCategoriesTab.vue?vue&type=script&lang=js"
export * from "./graficheCategoriesTab.vue?vue&type=script&lang=js"

import "./graficheCategoriesTab.vue?vue&type=style&index=0&id=0b683897&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b683897"]])

export default __exports__